import { styled } from "@mui/material";

export const Status = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 6,
});
